import { render, staticRenderFns } from "./CourseDaysList.vue?vue&type=template&id=a48c5234&lang=pug&"
import script from "./CourseDaysList.vue?vue&type=script&lang=js&"
export * from "./CourseDaysList.vue?vue&type=script&lang=js&"
import style0 from "./CourseDaysList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports